/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function t(t){return t&&"object"==typeof t&&"toJSON"in t&&"function"==typeof t.toJSON}export{t as isSerializable};
